module.exports = __webpack_public_path__ + "assets/favicons/mstile-150x150.10b0911e2fa7577a21634e865cd546a9.png";